import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { stopIntercom } from '../../../utility/intercom'
import { resetAnalytics } from '../../../utility/analytics'
import { successSigningOutUser } from '../../../actions/authActions'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

const PostLogoutPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(successSigningOutUser())
    stopIntercom()
    resetAnalytics()

    navigate('/', { replace: true })
  }, [dispatch, navigate])

  return <Loader message={t('auth.postLogout.loggingOut')} />
}

export default PostLogoutPage
